// extracted by mini-css-extract-plugin
export default {"breadcrumbLink":"BreadcrumbLink_breadcrumbLink__-O8S8"};